var _rect, _rect2, _g, _g2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStsGuideStanding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 320,
    viewBox: "0 0 200 320",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 198,
    height: 318,
    rx: 18,
    fill: "#FFFFFF",
    stroke: "#E3E7EE",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 40,
    width: 10,
    height: 222,
    fill: "#DADADA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6,22)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 58,
    width: 8,
    height: 182,
    rx: 2,
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 151,
    width: 96,
    height: 9,
    rx: 2,
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 160,
    width: 7,
    height: 80,
    rx: 2,
    fill: "#7D7D7D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(34,22)",
    fill: "#E9E9E9",
    stroke: "#8F8F8F",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 228,
    width: 30,
    height: 12,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 180,
    width: 14,
    height: 52,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 126,
    width: 16,
    height: 56,
    rx: 8
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 126,
    rx: 15,
    ry: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 80 Q84 72 94 70 L106 70 Q116 72 114 82 L111 112 Q109 118 101 118 L97 118 Q89 118 88 112 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 58,
    width: 9,
    height: 14,
    rx: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 101,
    cy: 42,
    rx: 14,
    ry: 18,
    transform: "rotate(8 101 42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 80,
    width: 12,
    height: 38,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 114,
    width: 11,
    height: 32,
    rx: 5.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 101,
    cy: 150,
    rx: 6,
    ry: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 81,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 116,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 181,
    r: 7
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 294,
    r: 8,
    fill: "#EE6C3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStsGuideStanding);
export default __webpack_public_path__ + "static/media/sts-guide-standing.b51a6a595a9defa9aeec4fdb7a192f68.svg";
export { ForwardRef as ReactComponent };